<template>
  <div class="rose">
    <div
      v-if="showTitle === true"
      class="titolo navy--text text--lighten-2 font-hemi-head pb-4 d-flex align-center"
    >
      <div class="mr-2">Rose</div>
    </div>

    <div v-if="showTitle" class="d-flex justify-center pb-4">
      <v-btn
        small
        outlined
        rounded
        class="navy--text text--lighten-4"
        @click="showDialogRoseLega"
      >Rose</v-btn>
    </div>

    <v-slide-group
      center-active
      show-arrows
      mandatory
      prev-icon="keyboard_arrow_left"
      next-icon="keyboard_arrow_right"
      v-model="squadra_slider"
      class="slider"
    >
      <v-slide-item
        v-for="(squadra, id) in asta_squadre"
        :key="id"
        v-slot="{ active, toggle }"
        :value="squadra.id"
      >
        <!-- lista squadre -->
        <div class="slider-squadra" :input-value="active" @click="toggle">
          <squadra-crediti small :id="squadra.id"></squadra-crediti>
        </div>
      </v-slide-item>
    </v-slide-group>

    <!--
    <v-btn
      depressed
      @click="removeSquadra"
      v-if="Config.STANDALONE && (admin || selected_squadra == user_uid)"
      icon
    >
      <v-icon>delete</v-icon>
    </v-btn> -->
    <div
      class="rose-squadra-content"
      v-for="(squadra, id_squadra) in asta_squadre"
      :key="id_squadra"
      v-show="id_squadra == selected_squadra"
    >
      <!-- modifica crediti squadra -->
      <div class="crediti-squadra">
        <crediti
          :crediti="crediti(id_squadra)"
          use-icon
        ></crediti>
        <v-btn
          icon
          x-small
          depressed
          color="navy darken-2"
          v-if="Config.STANDALONE"
          @click="promptEditCreditiSquadra(id_squadra)"
        >
          <v-icon small>mode_edit</v-icon>
        </v-btn>
      </div>

      <asta-rosa :id_squadra="id_squadra"></asta-rosa>
    </div>
  </div>
</template>

<script>
import db from "../js/db";
import mixins from "../js/mixins";
import toast from "../js/toast";

import Vuex from "vuex";
import Calciatore from "./common/Calciatore";
import SquadraCrediti from "./common/SquadraCrediti";
import AstaRosa from "./common/AstaRosa";
import Crediti from "./common/Crediti";
import { RecycleScroller } from "vue-virtual-scroller";

export default {
  name: "asta-rose",
  components: {
    Calciatore,
    AstaRosa,
    SquadraCrediti,
    Crediti,
    RecycleScroller,
  },
  mixins: [mixins, toast],
  props: {
    showTitle: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("--> AstaRose ready.");
  },
  destroyed() {
    console.log("<-- AstaRose destroyed.");
  },
  methods: {
    showDialogRoseLega() {
      db.emit("showDialogRoseLega");
    },
    crediti(id_squadra) {
      return this.asta_squadre[id_squadra].crediti;
    },
    // editCreditiSquadraCb(id_squadra) {
    //   if (!this.admin) {
    //     db.emit("swalAdmin");
    //     return;
    //   }

    //   if (this.isAstaInCorso) {
    //     db.emit("swalAstaInCorso");
    //     return;
    //   }
    //   let crediti = this.crediti(id_squadra);
    //   db.emit("showEditValore", id_squadra, crediti);
    // },
    // removeSquadra() {
    //   db.removeSquadra(this.selected_squadra);
    // },
    // editCreditiSquadra() {
    //   Swal.fire({
    //     title:
    //       'Modifica crediti "' + this.squadra(this.selected_squadra).name + '"',
    //     input: "number",
    //     inputValue: this.crediti(this.selected_squadra),
    //     inputAttributes: {
    //       min: 1,
    //     },
    //     showCancelButton: true,
    //     confirmButtonText: "Conferma",
    //     showLoaderOnConfirm: true,
    //     preConfirm: (crediti) => {
    //       return new Promise((resolve, reject) => {
    //         let crediti_old = "";
    //         if (
    //           this.asta_squadre[id_squadra] &&
    //           this.asta_squadre[id_squadra].crediti
    //         ) {
    //           crediti_old = this.asta_squadre[id_squadra].crediti;
    //         }
    //         db.modificaCreditiSquadra(this.selected_squadra, crediti).then(
    //           () => {
    //             this.astaLogCreditiSquadra(
    //               this.selected_squadra.id,
    //               crediti,
    //               crediti_old
    //             );
    //             resolve();
    //           }
    //         );
    //       });
    //     },
    //     allowOutsideClick: false,
    //   });
    // },

    // calciatori_sorted(calciatori) {
    //   if (calciatori) {
    //     var res = Utils.orderKeysBy(
    //       calciatori,
    //       [
    //         function (key) {
    //           return parseInt(this.calciatori[key].ID_Ruolo);
    //         }.bind(this),
    //         function (key) {
    //           return parseInt(calciatori[key]);
    //         }.bind(this),
    //         function (key) {
    //           return parseInt(this.calciatori[key].quotazione);
    //         }.bind(this),
    //       ],
    //       ["asc", "desc", "desc"]
    //     );
    //     res = _.mapValues(res, (value, key) => {
    //       return { ...value, id: key };
    //     });
    //     return res;
    //   }
    // },
  },
  computed: {
    // crediti_spesi() {
    //   return _.sumBy(
    //     _.values(this.selected_squadra.calciatori),
    //     function (o) {
    //       return o.p;
    //     }
    //   );
    // },
    squadra_slider: {
      get() {
        return this.selected_squadra;
      },
      set(value) {
        this.$store.dispatch("setSquadraSelected", value);
      },
    },
    ...Vuex.mapGetters(["selected_squadra"]),
  },
};
</script>
<style lang="scss" scoped>
.rose {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;

  .slider {
    padding-bottom: 15px;
    .slider-squadra {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      margin-right: 10px;
      padding-bottom: 5px;
      margin-bottom: 5px;
      &.v-slide-item--active {
        box-shadow: 0px 5px 0px -1px var(--v-secondary-base);
      }

      .ruoli-completati {
        display: flex;
        background: white;
        border-radius: 10px;
        padding: 1px;
      }
      .squadra-crediti {
        margin: 5px;
      }
    }
  }

  .crediti-squadra {
    flex: 0 0 auto;
    align-items: center;
    display: flex;
    justify-content: center;
    padding-bottom: 10px;
  }

  .rose-squadra-content {
    flex: 1 1 auto;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  // .recycle-scroller {
  //   // vale solo su mobile (=> dialog) perchè su desktop è overwritten da main.scss
  //   height: 400px;
  //   // serve per far scrollare solo la lista invece che tutta la dialog
  //   // serve per non far cambiare le della dialog
  // }
}
</style>
